import Typography from '@components/v2/ui/Typography/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import useDataQuery from '../../../../hooks/useDataQuery/useDataQuery';
import { ClarityEvents } from '../../../../lib/clarity/types/clarityEvents.types';
import { withEvent } from '../../../../lib/clarity/utils/captureEvent.utils';
import { ExtractPaginationType } from '../../../../services/types';
import { Pagination } from '../../../../types/pagination.type';
import { GenericQueryOutput } from '../../../Crud/filters/hooks/multiOptionsSelectorFilter/useMultiDynamicOptionsSelector/useMultiDynamicOptionsSelector.types';
import { MultiDynamicOptionsCreatorFilter } from '../../../Crud/filters/sharedBetweenFilters/types';
import { HandleSelectFilterProps } from '../../contexts/filterV3.context.types';
import { FILTER_LIST_ITEM_PADDING } from './constants';

interface FilterOptionCreatorListProps {
  onClick: (props: HandleSelectFilterProps) => void;
  option: MultiDynamicOptionsCreatorFilter;
}

const FilterOptionCreatorList = ({ onClick, option }: FilterOptionCreatorListProps) => {
  const { data: rawDynamicData } = useDataQuery<Pagination<
    ExtractPaginationType<GenericQueryOutput>
  > | null>({
    queryKey: option.multiDynamicOptionsCreatorArgs.filtersQueryKey(
      option.multiDynamicOptionsCreatorArgs.filtersQueryParams,
    ),
    queryFn: async () => {
      const data = await option.multiDynamicOptionsCreatorArgs.filtersQueryFn(
        option.multiDynamicOptionsCreatorArgs.filtersQueryParams,
      );

      if (!data.ok || !data.data) {
        throw new Error('Network response was not ok');
      }

      return data?.data;
    },
  });

  return (
    <>
      {(rawDynamicData?.data || []).map((data) => {
        const { keys } = option.multiDynamicOptionsCreatorArgs;

        return (
          <ListItemButton
            key={data[keys.filterId as string]}
            onClick={withEvent(
              `${ClarityEvents.LIST_FILTER_APPLIED_WITH_NAME} ${option.title}`,
              () => onClick({ filter: option, data }),
            )}
            sx={{ paddingInline: FILTER_LIST_ITEM_PADDING }}
          >
            <Typography component="span" color="textPrimary">
              {data[keys.filterTitle as string]}
            </Typography>
          </ListItemButton>
        );
      })}
    </>
  );
};

export default FilterOptionCreatorList;
